;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      shortcode: null,
      gateway: null,
      stkOpen: false,
      bank_account_number: "",
      initiating: false,
      base_url: "",
      payment_instructions: "",
      div_id: null,
      content_div: null,
      success_message: null,
      error_message: null,
      transfer_types: ["eft"],
      transaction_prefix: "C",
      selectedTransferType: null,
      transfer_code: null
    };
  },

  created: function created() {
    var id = this.$attrs["gid"];
    this.payment_instructions = this.$attrs["instructions"];
    this.div_id = "absaModal" + id;
    this.content_div = "contentDiv" + id;
  },
  mounted: function mounted() {
    var _this = this;

    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.shortcode = this.$attrs["shortcode"];
    this.gateway = this.$attrs["gateway"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.base_url = this.$attrs["base_url"];

    this.write_instructions(this.content_div, this.payment_instructions);
    this.set_total_amount();
    $("#" + this.div_id).on("hidden.bs.modal", function () {
      _this.error_message = null;
      _this.success_message = null;
      _this.initiating = false;
      _this.destroyTimer();
    });
  },
  computed: {
    valid_phone: function valid_phone() {
      if (this.bank_account_number) {
        return true;
      }
      return false;
    }
  },
  methods: {
    write_instructions: function write_instructions(div, instructions) {
      $("#" + div).html(instructions);
    },

    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    toggleStkOpen: function toggleStkOpen() {
      if (this.stkOpen) {
        this.stkOpen = false;
      } else {
        this.stkOpen = true;
      }
    },
    setTransferCode: function setTransferCode(value) {
      this.transfer_code = value;
    },
    destroyTimer: function destroyTimer() {
      this.transfer_code = null;
      this.bank_account_number = null;
      this.selectedTransferType = null;
      this.$refs.timer.destroyTimer();
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    fillaccount: function fillaccount(bank_account_number, code) {
      return this.transaction_prefix.concat(".").concat(code).concat(".").concat(bank_account_number);
    },
    stk_menu: function stk_menu() {
      var _this2 = this;

      this.initiating = true;
      this.error_message = null;
      this.success_message = null;
      var urlIs = this.base_url + "/api/payment/absa/checkout/initiate";
      var api_headers = {
        Authorization: ""
      };
      var params = {
        req_ref: this.invoice_number,
        amount: this.total_amount,
        gateway: this.gateway,
        transfer_code: this.selectedTransferType.toUpperCase(),
        account_number: this.fillaccount(this.bank_account_number, this.transfer_code)
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _this2.initiating = false;
          _this2.error_message = "Unable to begin payment process at this time. Try again later !";
        } else {
          _this2.initiating = false;
          window.top.location.href = response.data.url;
        }
      }).catch(function () {
        _this2.initiating = false;
        _this2.error_message = "Unable to begin payment process at this time. Try again later !";
      }).then(function () {
        _this2.initiating = false;
        _this2.toggleStkOpen();
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.div_id,"tabindex":"-1","role":"dialog","aria-labelledby":"absaModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using ABSA Online Banking")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                    "+_vm._s(_vm.currency)+" "+_vm._s(_vm.formatNumber(_vm.total_amount))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.error_message)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.error_message)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.success_message)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n                      Click\n                      "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toggleStkOpen}},[_vm._v("here")]),_vm._v("\n                      to start ABSA Online Banking payment process\n                      "),(_vm.stkOpen)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("Account Number\n                            "),(!_vm.valid_phone)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("* required")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank_account_number),expression:"bank_account_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter a valid ABSA Bank Account Number"},domProps:{"value":(_vm.bank_account_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bank_account_number=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('label',[_vm._v("Select Transfer Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTransferType),expression:"selectedTransferType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTransferType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select transfer type...")]),_vm._v(" "),_c('option',{attrs:{"value":"eft"}},[_vm._v("E.F.T")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.selectedTransferType=='eft')?_c('label',[_vm._v("Select Branch Code")]):_vm._e(),_vm._v(" "),(_vm.selectedTransferType=='eft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.transfer_code),expression:"transfer_code"}],staticClass:"form-control",attrs:{"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.transfer_code=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setTransferCode($event.target.value)}]}},[_c('option',{attrs:{"value":"001"}},[_vm._v("001")]),_vm._v(" "),_c('option',{attrs:{"value":"002"}},[_vm._v("002")]),_vm._v(" "),_c('option',{attrs:{"value":"003"}},[_vm._v("003")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.selectedTransferType=='rtgs')?_c('label'):_vm._e(),_vm._v(" "),(_vm.selectedTransferType=='rtgs')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.transfer_code),expression:"transfer_code"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.transfer_code=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"SBICTZT0"}},[_vm._v("SBICTZT0")])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.valid_phone && _vm.transfer_code)?_c('div',{staticClass:"row"},[(_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary"},[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n                            Processing ...\n                          ")]):_vm._e(),_vm._v(" "),(!_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":_vm.stk_menu}},[_vm._v("\n                            Proceed\n                          ")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('li',[_vm._v("You will be redirected to the ABSA Online banking channel")]),_vm._v(" "),_c('li',[_vm._v("Enter your ABSA Online Banking username and password, once redireceted")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                    After you receive a successful reply from ABSA Online Banking, click\n                    the complete button below.\n                  ")])]),_vm._v(" "),(_vm.payment_instructions)?_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Or follow instructions below")]),_vm._v(" "),_c('div',{attrs:{"id":_vm.content_div}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"absa","status_api_url":_vm.url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}})],1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c6bf769", __vue__options__)
  } else {
    hotAPI.reload("data-v-0c6bf769", __vue__options__)
  }
})()}